import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const Scrollto = () => {


    const location = useLocation();

    useEffect(()=>{
  
            window.scrollTo({
                top:0,
                behavior:"smooth"
            })
        

      
    },[location])
  return 
}

export default Scrollto
